import tmhRequest from '@/config/tmhRequest'

export default {

  searchCardStoreScope: function (data) {
    return tmhRequest({
      url: '/project/tmh/cardstorescope/searchcardstorescope',
      method: 'post',
      params: data,
    })
  },

  searchListCardStoreScope: function (data) {
    return tmhRequest({
      url: '/project/tmh/cardstorescope/searchlistcardstorescope',
      method: 'post',
      params: data,
    })
  },

  addCardStoreScope: function (data) {
    return tmhRequest({
      url: '/project/tmh/cardstorescope/addcardstorescope',
      method: 'post',
      data: data,
    })
  },

  initCardStoreScope: function (data) {
    return tmhRequest({
      url: '/project/tmh/cardstorescope/initcardstorescope',
      method: 'post',
      params: data,
    })
  },

  editCardStoreScope: function (data) {
    return tmhRequest({
      url: '/project/tmh/cardstorescope/editcardstorescope',
      method: 'post',
      data: data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/tmh/item/cardstorescope.js